import { isEmpty } from '@intelligence/v3/utils/common';

export interface IReportConfig {
  display_source?: string;
}

export type TReportConfigMap = IRecord<IReportConfig>;

interface IReport {
  resource_id?: string;
  source?: string;
}

/** 获取报告的最终展示配置，未配置的数据源回退到报告当前值 */
export const resolveReportConfig = (report: IReport, config: TReportConfigMap): IReportConfig => {
  if (isEmpty(report)) {
    return {};
  }

  const reportConfig = isEmpty(config) ? undefined : config[report.resource_id || ''];

  return {
    ...reportConfig,
    display_source: reportConfig?.display_source || report.source || '',
  };
};
